import { useState } from 'react'

const readStored = (key: string, fallback: number): number => {
  const raw = window.sessionStorage.getItem(key)
  const parsed = raw === null ? NaN : Number(raw)
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback
}

/**
 * Página e linhas-por-página de uma tabela, persistidas em sessionStorage sob
 * `storageKey` — sobrevive a abrir um item da lista (troca de pageMode local
 * ou navegação para uma página de detalhe) e voltar, mantendo a página em que
 * o utilizador estava. Limpa-se ao fechar o separador.
 */
export function useTablePagination(storageKey: string, defaultRowsPerPage = 10) {
  const pageKey = `${storageKey}:page`
  const rowsPerPageKey = `${storageKey}:rowsPerPage`

  const [page, setPageState] = useState(() => readStored(pageKey, 0))
  const [rowsPerPage, setRowsPerPageState] = useState(() => readStored(rowsPerPageKey, defaultRowsPerPage))

  const setPage = (value: number) => {
    setPageState(value)
    window.sessionStorage.setItem(pageKey, String(value))
  }
  const setRowsPerPage = (value: number) => {
    setRowsPerPageState(value)
    window.sessionStorage.setItem(rowsPerPageKey, String(value))
  }

  return { page, setPage, rowsPerPage, setRowsPerPage } as const
}
